import { Radio, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { CHECKBOX, FREE_TEXT, horizontalScrollTableStyle, RADIO } from '../../constants';
import { ColumnProps, RowProps, TabularAnswer } from '../../models/global';
import TextField from '../FormComponents/TextField';
import '../SurveyForm/SurveyForm.scss';

interface MatriceComponentProps {
  matrice: {
    columns: [] | ColumnProps[];
    rows: [] | RowProps[];
  };
  language: string;
  readonly?: boolean;
  sectionId: string;
  changeTabularAnswer: (
    value: string | boolean,
    columnType: string,
    sectionId: string,
    columnId: string,
    rowId: string,
    rowKey: string,
    matrixType?: string,
  ) => void;
  tabularAnswers: TabularAnswer[];
  marginTop?: number;
  isReference?: boolean;
}

function UserMatriceComponent(props: MatriceComponentProps) {
  const { matrice, language, readonly, sectionId, tabularAnswers, changeTabularAnswer, marginTop, isReference } = props;
  const matrixType = matrice?.columns?.[0]?.type;
  const getField = (type: string, columnId: string, rowId?: string) => {
    switch (type) {
      case CHECKBOX:
        return (
          <Checkbox
            checked={!!tabularAnswers.find(el => el.columnId === columnId && el.rowId === rowId)?.checked}
            onChange={(_, checked) => changeTabularAnswer(checked, CHECKBOX, sectionId, columnId, rowId, 'rowId')}
            size='small'
          />
        );
      case RADIO:
        return (
          <Radio
            checked={!!tabularAnswers.find(el => el.columnId === columnId && el.rowId === rowId)?.checked}
            onChange={(_, checked) => changeTabularAnswer(checked, RADIO, sectionId, columnId, rowId, 'rowId')}
            size='small'
          />
        );
      case FREE_TEXT:
        return (
          <TextField
            id='Other'
            label='Other'
            variant='standard'
            sx={{
              ml: 2,
              ...(isReference && {
                '& .MuiFormLabel-root': {
                  fontSize: '0.9rem',
                },
              }),
            }}
            value={tabularAnswers.find(el => el.columnId === columnId && el.rowId === rowId)?.answer || ''}
            onChange={e =>
              changeTabularAnswer(e.target.value, FREE_TEXT, sectionId, columnId, rowId, 'rowId', matrixType)
            }
            InputProps={{
              style: {
                fontSize: isReference ? '0.9em' : '1em',
              },
            }}
          />
        );
    }
  };

  return (
    <Box sx={{ mt: marginTop }} className='table-container' style={{ pointerEvents: 'visible' }}>
      <TableContainer component={Paper} sx={{ ...horizontalScrollTableStyle, mt: 2.5 }}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow
              sx={{
                pl: 2,
              }}
            >
              {matrice?.rows?.length && <Box className='user-row-info'></Box>}
              {matrice?.columns.map((matriceCol: ColumnProps) => (
                <TableCell key={matriceCol.id}>
                  <Typography variant={isReference ? 'caption' : 'body2'}>
                    {language === 'English' || !matriceCol[`name${language}`]
                      ? matriceCol.name
                      : `${matriceCol[`name${language}`]}`}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={readonly ? { pointerEvents: 'none' } : {}}>
            {matrice?.rows.map(row => (
              <TableRow
                key={row.id}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  pl: 2,
                }}
              >
                <Box className='user-row-info'>
                  <Typography variant={isReference ? 'caption' : 'body2'}>
                    {language === 'English' || !row[`name${language}`] ? row.name : `${row[`name${language}`]}`}
                  </Typography>
                </Box>
                {matrice?.columns.map((column: ColumnProps, index: number) => (
                  <TableCell component='td' scope='row' key={index}>
                    {getField(column.type, column.id, row.id)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default UserMatriceComponent;
